/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { WebSocketConnection } from '@app/core/services/websocket-connection.service';
import { Dashboard } from '@app/core/types';
import { DashboardGroup } from '@shared/types/common';
import { omit } from 'lodash-es';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class DashboardApiService {
  constructor(
    private http: HttpClient,
    private ws: WebSocketConnection,
  ) {}

  subscribeToWorkspaceGroups(): Observable<DashboardGroup[]> {
    return this.ws.getTopic<DashboardGroup[]>('/user/topic/workspace/groups');
  }

  createGroup(group: DashboardGroup) {
    return this.http.put<void>('api/v1/workspace/group', group);
  }
  updateGroup(group: DashboardGroup) {
    return this.http.patch<void>(`api/v1/workspace/group/${group.id}`, omit(group, 'id'));
  }
  deleteGroup(id: string) {
    this.http.delete<void>(`api/v1/workspace/group/${id}`);
  }
  getGroup(name: string) {
    return this.http.get<DashboardGroup>(`api/v1/workspace/group/${name}`);
  }

  create(db: Dashboard, groupId?: string) {
    const ending = groupId ? `/${groupId}` : '';
    return this.http.put<void>(`api/v1/workspace${ending}`, {
      id: db.id,
      jsonModel: JSON.stringify(db),
    });
  }
  update(db: Dashboard) {
    return this.http.patch<void>(`api/v1/workspace/${db.id}`, { jsonModel: JSON.stringify(db) });
  }
  delete(id: string) {
    return this.http.delete<void>(`api/v1/workspace/${id}`);
  }
  get(id: string): Observable<Dashboard> {
    return this.http
      .get<{ id: string; jsonModel: string }>(`api/v1/workspace/${id}`)
      .pipe(map((res) => JSON.parse(res.jsonModel)));
  }
}
